import React from 'react';
import styles from './disk.module.scss';

const DiskUsage = ({ diskUsage }) => {
  return (
    <div className={styles.diskUsage}>
      <h2>Disk Usage Information</h2>
      <table className={styles.table}>
        <thead>
          <tr>
            {diskUsage.length > 0 &&
              Object.keys(diskUsage[0]).map((header) => (
                <th key={header}>{header}</th>
              ))}
            <th className={styles.disk_usage}>Usage</th>
          </tr>
        </thead>
        <tbody>
          {diskUsage.map((row, index) => {
            const usagePercentage = parseInt(row['Use%'], 10);
            const barStyle = {
              width: `${usagePercentage}%`, // 백분율 기반 너비 설정
              background:
                usagePercentage >= 90
                  ? 'linear-gradient(to right, #0000cc, #ff8833, #ff3333)'
                  : usagePercentage >= 80
                  ? 'linear-gradient(to right, #0000cc, #db6361, #ff33eb)'
                  : usagePercentage >= 70
                  ? 'linear-gradient(to right, #0000cc, #357fce, #8100cc)'
                  : usagePercentage >= 60
                  ? 'linear-gradient(to right, #0000cc, #6d33ff, #3d2ad1)'
                  : '#0000cc',
            };

            return (
              <tr key={index}>
                {Object.values(row).map((value, idx) => (
                  <td key={idx}>{value}</td>
                ))}
                <td>
                  <div className={styles.progressBarWrapper}>
                    <div className={styles.progressBar} style={barStyle}></div>
                    <span className={styles.progressText}>{row['Use%']}</span>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DiskUsage;
